import React, { useState } from 'react';
import { Box, Typography, TextField, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { styles } from './styles';
import { useSubscription } from 'AppRoutes/context/SubscriptionContext';
import EditBreadcrumbs from 'components/EditBreadcumbs';

const EditName: React.FC = () => {
  const { personalData } = useSubscription();
  const [name, setName] = useState(personalData.fullName);
  const navigate = useNavigate();

  const handleSave = () => {
    navigate('/my-account'); // redireciona de volta após salvar
  };

  return (
    <Box sx={styles.container}>
      <EditBreadcrumbs current="Editar nome" />
      <Typography variant="h5" sx={styles.title}>
        Altere seu nome
      </Typography>
      <Typography sx={styles.description}>
        Se quiser alterar o nome associado à sua conta, você poderá fazê-lo a
        seguir. Lembre-se de clicar no botão <strong>Salvar alterações</strong>{' '}
        quando tiver concluído.
      </Typography>
      <TextField
        fullWidth
        label="Novo nome"
        value={name}
        onChange={e => setName(e.target.value)}
        sx={styles.input}
      />
      <Button variant="contained" sx={styles.button} onClick={handleSave}>
        Salvar alterações
      </Button>
    </Box>
  );
};

export default EditName;
